import { IChatInfoMessageExternalProps, IChatInfoMessageProps } from "./~types/ChatInfoMessageProps";
import './ChatInfoMessageItem.css';
import { getChatTypeClass } from "src/app/shared/helpers/chat-name-helper/ChatTypeHelper";
import { Button } from "reactstrap";
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import ChatTypeIcon from "src/app/shared/components/chat-type-icon/ChatTypeIcon";
import { GetChannelImage } from "src/app/shared/helpers/img-helpers/ImgHelper";
import { IApplicationState } from "src/~store/models/ApplicationState";
import { chatSummarySelector, isReceivingChatSummarySelector } from "src/app/chats-panel/~store/selectors";
import { getChatSummary } from "src/app/chats-panel/~store/actions/actions";
import { connect } from "react-redux";
import React, { useState } from "react";
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import { useTranslation } from "react-i18next";
import ChatSummaryStatusLabel from "./chat-summary-status-label/ChatSummaryStatusLabel";

type ReduxType = ReturnType<typeof mapStateToProps> & IChatInfoMessageProps;

function ChatInfoMessageItem(props: ReduxType) {
    const { t } = useTranslation();
    const [isSummaryOpened, setIsSummaryOpened] = useState(false);
    
    const _onViewSummaryClick = () => {
        if (props.messageItem.chatSummaryId && !props.isReceivingChatSummary) {
            props.getChatSummary(props.messageItem.chatSummaryId);
            setIsSummaryOpened(true);
        }
    }

    const _onSummaryClose = () => {
        setIsSummaryOpened(false);
    }
    
    const _getChatSummaryHeader = () => {
        return (
            <div className="summary-header-wrapper">
                <div className="summary-header-title-wrapper">
                    <div>
                        {t('chat.summary')}
                    </div>
                    <div>
                        {props.summary?.status && <ChatSummaryStatusLabel status={props.summary?.status}/>}
                    </div>

                </div>
                <div className="summary-header__close-button-wrapper">
                    <Button
                        className="summary-header__close-button red"
                        onClick={() => {
                            _onSummaryClose();
                        }}>
                        <i className="material-icons">
                            close
                        </i>
                    </Button>
                </div>
            </div>
        )
    } 

    const _getSummaryBody = () => {
        return (
            <div className="summary-body-wrapper">
                {
                    props.summary && 
                    <div className="summary-body__summary-text">
                        {props.summary.summaryText}
                    </div>
                }
            </div>
        )
    }
    
    const _getSummaryFooter = () => {
        return (
            <div className="summary-footer-wrapper">
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className={"chat-info-message " + getChatTypeClass(props.messageItem.chatType)}>
                <div className="chat-info-message__flex-container">
                    {
                        props.messageItem.chatSummaryId &&
                        <Button size="small" className="chat-info-message__chat-summary-button"
                            onClick={_onViewSummaryClick}>
                            {t('chat.summary')}
                            <SummarizeOutlinedIcon></SummarizeOutlinedIcon>
                        </Button>
                    }
                    <img className="message-item__chat-messenger-img"
                        src={GetChannelImage(props.messageItem.channelType)} />
                    {t('common.chat')} {props.messageItem.text}
                    <ChatTypeIcon chatType={props.messageItem?.chatType} tooltipPlacement={'right'}/>
                </div>
            </div>
            <ModalWindow className="summary-modal"
                isOpen={isSummaryOpened}
                header={_getChatSummaryHeader()}
                footer={_getSummaryFooter()}
                body={_getSummaryBody()}
                onClose={_onSummaryClose}
                >

            </ModalWindow>
        </React.Fragment>
    )
}

const mapStateToProps = (state: IApplicationState, externalProps: IChatInfoMessageExternalProps) => {
    return {
        summary: chatSummarySelector(state),
        isReceivingChatSummary: isReceivingChatSummarySelector(state),
        messageItem: externalProps.messageItem,
    };
};

const mapDispatchToProps = (dispatch: any): IChatInfoMessageProps => {
    return {
        getChatSummary: (
            chatSummaryId: number,
        ) => {
            return dispatch(getChatSummary(chatSummaryId));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatInfoMessageItem);
